const inOutTypeMap = {
    PURCIN: '采购入库',
    PURCOUT: '采购退货',
    SALEOUT: '销售出货',
    SALERETURN: '销售退货',
    OTHERIN: '其它入库',
    OTHEROUT: '其它出库',
    RESERVEINITIALIZE: '库存初始化',
    STOCKPROFIT: '盘盈入库',
    STOCKLOSS: '盘亏出库',
    MOVEIN: '移仓单',
    MOVEOUT: '移仓单',
    MAKEPICK: '生产领料',
    MAKERETURN: '生产退料',
    MAKEIN: '完工入库',
    OSMAKEPICK: '外协领料',
    OSMAKERETURN: '外协退料',
    OSMAKEIN: '外协入库',
    OSMAKEINBACK: '外协退货',
    MAKEDISMANTLE: '工单拆件',
    OSMAKEDISMANTLE: '外协拆件',
    CUSTPRODIN: '客供入库',
    CUSTPRODOUT: '客供退料',
    OthPayables: '应付调账单',
    GOODSSEND: '发出商品初始化',
    ESTIMATE: '暂估初始化',
    MAKEDISASSEMBLEPICK: '拆解工单领料',
    MAKEDISASSEMBLEIN: '拆解工单入库',
    AFTERSALEPICK: '售后领料',
    AFTERSALEIN: '售后入库',
    AFTERSALEOUT: '售后出货'
}

export default {
    parseInOutType(type) {
        return inOutTypeMap[type] || type;
    }
}